// extracted by mini-css-extract-plugin
module.exports = {"container1":"user_container1__2Egan","main":"user_main__3VZKq","user_element":"user_user_element__1ISzx","box":"user_box__OiTxY"};